import React, { useEffect, useState } from 'react';
import axios from "axios";
import AdminLayout from "./adminLayout"; // adjust path as needed

const AdminCorporateRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/corporate-enquiries/getenquire`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        setRequests(response.data); // Fixed: use response.data instead of response.json()
      } catch (error) {
        console.error('Error fetching corporate requests:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRequests();
  }, []);

  return (
    <AdminLayout>
      <div className="max-w-6xl mx-auto p-6">
        <h2 className="text-3xl font-bold mb-6 text-green-700">Corporate Plant Rental Requests</h2>

        {loading ? (
          <p className="text-center text-gray-600">Loading requests...</p>
        ) : requests.length === 0 ? (
          <p className="text-center text-gray-500">No corporate rental requests found.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {requests.map((req, index) => (
              <div
                key={index}
                className="bg-white border shadow-md rounded-2xl p-5 space-y-2 hover:shadow-lg transition"
              >
                <p><span className="font-semibold">Company:</span> {req.companyName}</p>
                <p><span className="font-semibold">Name:</span> {req.fullName}</p>
                <p><span className="font-semibold">Email:</span> {req.email}</p>
                <p><span className="font-semibold">Phone:</span> {req.phone}</p>
                <p><span className="font-semibold">Address:</span> {req.officeAddress}</p>
                <p><span className="font-semibold">Plant Type:</span> {req.typeOfPlants}</p>
                <p><span className="font-semibold">Quantity:</span> {req.numberOfPlants}</p>
                <p><span className="font-semibold">Maintenance:</span> {req.maintenanceRequired ? 'Yes' : 'No'}</p>
                <p><span className="font-semibold">Preferred Date:</span> {req.preferredStartDate}</p>
                {req.message && (
                  <p><span className="font-semibold">Message:</span> {req.message}</p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminCorporateRequests;
